import { Component, OnInit, Input } from '@angular/core';

import { GenericService } from '../../services/generic.service';
import { AggregationService } from '../../services/aggregation.service';

import { AccountBalanceInfo } from './services/accounts-balance/account-balance-info';

import { AccountsService } from './services/accounts.service';
import { AccountsBalanceService } from './services/accounts-balance/accounts-balance.service';
import { AccountAdditionalInfoService } from './services/account-additional-info/account-additional-info.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {

  @Input()
  productType: string;

  @Input()
  clearCache = false;

  accountsInfo: any;
  redesign: boolean = false;

  constructor(
    private genericService: GenericService,
    private aggregationService: AggregationService,
    private accountsService: AccountsService,
    private accountsBalanceService: AccountsBalanceService,
    private accountAdditionalInfoService: AccountAdditionalInfoService
  ) { }

  ngOnInit(): void {
    this.fetchAccounts();
    this.genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
    });
  }

  private fetchAccounts(): void {
    this.accountsService.getAccounts(this.productType, this.clearCache).subscribe(
      accountsInfo => {
        if (accountsInfo) {
          if (accountsInfo.responseCode === '403') {
            this.genericService.callUiLogger(accountsInfo.responseStatus);
            this.aggregationService.emitAggDone();
          }
          this.genericService.addDynamicProductTypeData(accountsInfo.contractSummaryResponse || [], this.productType);
          this.accountsInfo = accountsInfo;
          if (accountsInfo.contractSummaryResponse && accountsInfo.contractSummaryResponse.contractSummary) {
            this.initiateAccountBalanceInfoUpdate();
            this.initiateAccountAdditionalInfoUpdate();
          } 
        } else {
          this.accountsInfo = {};
          this.genericService.addDynamicProductTypeData({contractSummary: [], responseCode: '200'}, this.productType);
        }
        this.accountsInfo.businessUnit = this.accountsInfo.businessUnit ? this.accountsInfo.businessUnit : "Investments";
      //  this.aggregationService.emitAggDone();
      },
      error => {
        let errmsg = error.error || {};
        if (error.responseCode === '403') {
          this.genericService.callUiLogger(errmsg);
        }
        this.accountsInfo = errmsg;
        this.accountsInfo.businessUnit = "Investments";
        if (!errmsg.responseCode)
          this.accountsInfo.responseCode = error.responseCode;
        console.log("contractsummary error: ", this.accountsInfo);
        this.aggregationService.emitAggDone();
      }
    );
  }

  private initiateAccountBalanceInfoUpdate(): void {
    const accountReferenceIds = this.getAccountReferenceIdsForValueRefresh();
    if (accountReferenceIds.length === 0) {
      this.resetValueRefreshDisplay();
      return;
    }

    this.accountsBalanceService.getAccountsBalance(this.productType, accountReferenceIds).subscribe(
      (accountBalancesInfo: AccountBalanceInfo[]) => {
        this.updateAccountBalances(accountBalancesInfo);
        this.resetValueRefreshDisplay();
      }
    );
  }

  private initiateAccountAdditionalInfoUpdate(): void {
    const accountInfos = this.getAccountInfos();

    if (accountInfos.length === 0) {
      return;
    }

    this.accountAdditionalInfoService.getAdditionalSecondaryInfos(accountInfos).subscribe(
      (accountAdditionalInfos: any[]) => {
        this.updateAccountSecondaryInfos(accountAdditionalInfos);
      }
    );
  }

  private getAccountReferenceIdsForValueRefresh(): string[] {
    return this.getAccountInfos().filter(account => {
      return account.needValueRefresh;
    }).map(account => {
      return account.referenceId;
    });
  }

  private getAccountInfos(): any[] {
    let contracts;

    try {
      contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
    } catch (e) {
      return [];
    }

    return contracts.filter(contract => {
      return contract && contract.referenceId;
    }).map(contract => {
      return {
        referenceId: contract.referenceId,
        needValueRefresh: contract.needValueRefresh,
        sweepOption: contract.additionalValues ? contract.additionalValues.sweepOption : null,
        interestYTD: contract.additionalValues ? contract.additionalValues.interestYTD : null
      };
    });
  }

  private resetValueRefreshDisplay(): void {
    let contracts;

    try {
      contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
    } catch (e) {
      // nothing here
    }

    for (const contract of contracts) {
      if (contract) {
        contract.needValueRefresh = false;
      }
    }
  }

  private updateAccountBalances(accountBalancesInfo: AccountBalanceInfo[]): void {
    if (!accountBalancesInfo || accountBalancesInfo.length === 0) {
      return;
    }

    let contracts;

    try {
      contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
    } catch (e) {
      return;
    }

    for (const balanceInfo of accountBalancesInfo) {
      for (const contract of contracts) {
        if (contract.referenceId === balanceInfo.referenceId) {
          try {
            contract.primaryContractValue.value = balanceInfo.accountValue + '';
          } catch (e) {
            // nothing here
          }

          contract.asOfDate = balanceInfo.asOfDate;
        }
      }
    }

    this.genericService.addDynamicProductTypeData(
      this.accountsInfo.contractSummaryResponse,
      this.productType
    );
  }

  private updateAccountSecondaryInfos(accountSecondaryInfos: any[]): void {
    if (!accountSecondaryInfos || accountSecondaryInfos.length === 0) {
      return;
    }

    let contracts;

    try {
      contracts = this.accountsInfo.contractSummaryResponse.contractSummary;
    } catch (e) {
      return;
    }

    for (const accountSecondaryInfo of accountSecondaryInfos) {
      for (const contract of contracts) {
        if (contract.referenceId === accountSecondaryInfo.referenceId) {
          try {
            let currentFirstSecondaryValueGroup: any[];

            contract.secondaryContractValues = contract.secondaryContractValues || [];
            contract.secondaryContractValues[0] = contract.secondaryContractValues[0] || { group: [] };
            contract.secondaryContractValues[0].group = contract.secondaryContractValues[0].group || [];

            currentFirstSecondaryValueGroup = contract.secondaryContractValues[0].group;

            contract.secondaryContractValues[0].group =
              currentFirstSecondaryValueGroup.concat(accountSecondaryInfo.secondaryContractValues);
          } catch (e) {
            // nothing here
          }
        }
      }
    }
  }
}
